import { clientApi } from '@/config/axios';
import type { Edition } from './AuthContext';

export interface PersonalSignupBody {
  email: string;
  name: string;
  password: string;
}

export interface ProfessionalSignupBody extends PersonalSignupBody {
  organization_name: string;
}

export interface SignupResponse {
  access_token: string;
  organization: {
    id: string;
    name: string;
    settings: Record<string, unknown> | null;
    edition: Edition;
    created_at: string;
    updated_at: string;
  };
  refresh_token: string;
  token_type: 'bearer';
  user: {
    id: string;
    email: string;
    name: string;
    is_superuser: boolean;
  };
}

export async function signupPersonal(body: PersonalSignupBody): Promise<SignupResponse> {
  const { data } = await clientApi.post<SignupResponse>('/api/v1/auth/signup/personal', body);
  return data;
}

export async function signupProfessional(body: ProfessionalSignupBody): Promise<SignupResponse> {
  const { data } = await clientApi.post<SignupResponse>('/api/v1/auth/signup/professional', body);
  return data;
}
